import React from "react";
import PropTypes from "prop-types";
import { Item } from "semantic-ui-react";
import Link from "next/link";
import { styles } from "./element.js";

import { getOrdinalSuffix, customdecodeURIComponent } from "../../common/Utils";

const ItemData = ({
  source,
  head,
  subhead,
  desc,
  extra,
  href,
  customclass,
  onClick,
  keydata,
  license,
  ispage,
  ...props
}) => {
  let nhsummary = "";
  if (extra) {
    if (extra.length > 54) {
      nhsummary = extra.slice(0, 100) + "...";
    } else {
      nhsummary = extra;
    }
  }

  return (
    // <div className="responsive-border" style={{ padding: "0px 5px" }}>
    <Item.Group
      className="responsive-border top-nh-list"
      style={{ padding: "8px 5px 8px 5px" }}
    >
      <Item className="items-desc">
        {ispage === "detailcity" && (
          <div className="nh_ranking_rating_main">
            <div className="nh_ranking_rating">
              {keydata + 1}
              <sup className="nh_ranking_suffix">
                {getOrdinalSuffix(keydata + 1)}
              </sup>
            </div>
          </div>
          // <span className="city_nh_rank">
          //   <strong>#{keydata + 1}</strong>
          // </span>
        )}
        <Link
          href={href}
          title={href}
          style={{ cursor: "pointer", marginRight: 5 }}
          target="_blank"
          className={ispage === "detailcity" ? "detailcity_nh_img" : ""}
        >
          {/* <a
            style={{ cursor: "pointer", marginRight: 5 }}
            target="_blank"
            title={href}
            className={ispage === "detailcity" ? "detailcity_nh_img" : ""}
          > */}
          {ispage === "p_flyer" ? (
            <Item.Image
              {...props}
              as="img"
              src={source + "?cacheblock=true"}
              className={customclass ? customclass : ""}
              crossOrigin="anonymous"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src =
                  process.env.NEXT_PUBLIC_CDN_ID +
                  "static/images/defaultnhmap.jpg";
              }}
              alt="Neighborhood Iamge"
              title="Neighborhood Iamge"
            />
          ) : (
            <Item.Image
              as="img"
              {...props}
              src={source}
              className={customclass ? customclass : ""}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src =
                  process.env.NEXT_PUBLIC_CDN_ID +
                  "static/images/defaultnhmap.jpg";
              }}
              alt="Neighborhood Iamge"
              title="Neighborhood Iamge"
            />
          )}
          {/* </a> */}
        </Link>
        <Item.Content verticalAlign="top" className="img-item-desc">
          <Link href={href} target="_blank" style={styles.header}>
            {/* <a target="_blank" style={styles.header}> */}
            <Item.Header content={head} style={{ cursor: "pointer" }} />
            {/* </a> */}
          </Link>
          {license ? (
            <Item.Meta content={license} style={styles.metaItems} />
          ) : null}
          {subhead ? (
            <Item.Meta content={subhead} style={styles.metaItems} />
          ) : null}
          {/* {desc ? (
            <Item.Description
              content={
                ispage === "detailsnh" || ispage === "detailcity"
                  ? desc.replace("-", "")
                  : desc
              }
              {...props}
            />
          ) : null}
          {(ispage === "detailsnh" || ispage === "detailcity") &&
          desc &&
          desc !== "-" &&
          parseInt(
            desc.replace("Value", "").replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, "")
          ) > 0 ? (
            <span className="over_val">Overvalued</span>
          ) : desc &&
            parseInt(
              desc
                .replace("Value", "")
                .replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, "")
            ) < 0 ? (
            <span className="under_val">Undervalued</span>
          ) : (
            ""
          )} */}
          {extra ? (
            <Item.Extra content={nhsummary} style={styles.extraItems} />
          ) : null}
        </Item.Content>
      </Item>
    </Item.Group>
    // </div>
  );
};

ItemData.propTypes = {
  source: PropTypes.string,
  head: PropTypes.any,
  subhead: PropTypes.any,
  description: PropTypes.any,
  desc: PropTypes.any,
  extra: PropTypes.any,
};
export default ItemData;
